// Module
var code = `<div class="alert alert-info" xmlns="http://www.w3.org/1999/html">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to manual reconcile ACWP and ACWP_OFI Outgoing Instapay Transfer with Bancnet's instructions. IT SHOULD NOT BE USED WITHOUT SUCH INSTRUCTIONS, AS MISUSE MAY RESULT IN FINANCIAL LOSSES BEYOND NEXTBANK'S CONTROL.
  </span>

</div>

<div class="alert alert--danger">
  Please double check the transfers to be reconciled, since there is no revert on this action.
  <br>
  Only one transfer identifier should be present per line, Either transfer reference number or transfer provider reference number.
  <br>
  Only one transfer rejection status should be present per line, Either the rejection status code or rejection proprietary status code.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>File:</td>
      <td>
        <file-upload
          ng-model="\$ctrl.contentFile"
          required
          validate-uploaded
          max-files="1"
          show-file-name="true"
          show-remarks="false"
          enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div ng-if="\$ctrl.result != null">
    <h2 class="section-header">Transfer manual reconciliation summary</h2>

    <div ng-if="\$ctrl.result.failedRejections.length > 0">

      <div class="alert alert--danger file-error-alert" >
        Failed transfers manual reconciliation:
      </div>

      <dynamic-list
        columns="\$ctrl.columns"
        data="\$ctrl.result.failedRejections"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.result.successfulRejections.length > 0">
      <div class="alert file-error-alert" >
        Successful transfers manual reconciliation:
      </div>

      <dynamic-list
        columns="\$ctrl.columns"
        data="\$ctrl.result.successfulRejections"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>
  </div>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid || \$ctrl.result"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.result === null"
      ng-click="\$ctrl.clear()">
      Clear
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/outgoing-instapay-transfer-manual-recon/outgoing-instapay-transfer-manual-recon.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;